import React from 'react';

interface MetricCardProps {
  eyebrow: string;
  title: string;
  value: string;
  tone?: 'emerald' | 'blue' | 'amber' | 'rose' | 'slate';
}

const MetricCard: React.FC<MetricCardProps> = ({
  eyebrow,
  title,
  value,
  tone = 'slate',
}) => {
  return (
    <article className={`admin-metric-card admin-metric-card--${tone}`}>
      <p className="admin-metric-card__eyebrow">{eyebrow}</p>
      <h3>{title}</h3>
      <strong>{value}</strong>
    </article>
  );
};

export default MetricCard;